<script setup>
import {usePortalContentAndDesignStore} from "../../../../../stores/partners/portalContentAndDesignStore";
import TextField from "../../../../../elements/forms/TextField.vue";
import TextEditor from "../../../../../elements/TextEditor.vue";
import RadioGroupInline from "../../../../../elements/forms/RadioGroupInline.vue";
import { watch } from 'vue';

const portalContentAndDesignStore = usePortalContentAndDesignStore();

// Watchers for reactive updates
watch(() => portalContentAndDesignStore.dashboardPageSettings.refer_a_friend_portal_page_title, (newValue) => {
    // Title updated
});

watch(() => portalContentAndDesignStore.dashboardPageSettings.refer_a_friend_portal_page_description, (newValue) => {
    // Description updated
});
</script>

<template>
    <div class="divide-y">
        <!-- Loading state -->
        <div v-if="!portalContentAndDesignStore.dashboardDataLoaded" class="space-y-4 text-center py-8">
            <div class="text-gray-500">Loading dashboard data...</div>
        </div>
        
        <!-- Page Details -->
        <div v-else class="space-y-4">
            <text-field
                label="Title"
                name="refer_a_friend_portal_page_title"
                type="text"
                v-model="portalContentAndDesignStore.dashboardPageSettings.refer_a_friend_portal_page_title"
            >
            </text-field>

            <text-editor
                name="refer_a_friend_portal_page_description"
                :text="portalContentAndDesignStore.dashboardPageSettings.refer_a_friend_portal_page_description || ''"
                @input="(newValue) => { portalContentAndDesignStore.dashboardPageSettings.refer_a_friend_portal_page_description = newValue }"
            >
            </text-editor>

            <radio-group-inline
                label="Branding"
                name="referral_portal_dashboard_branding"
                v-model="portalContentAndDesignStore.dashboardPageSettings.refer_a_friend_portal_dashboard_branding"
                :options="[
                    { value: 'none', label: 'None'},
                    { value: 'symbol', label: 'Symbol'},
                    { value: 'logo', label: 'Logo'}
                ]">
            </radio-group-inline>
        </div>
    </div>
</template>
